import { GetStaticPaths, GetStaticProps } from 'next';
import { getLocalePaths } from '@i18n';

// Pages
import CpaEpnbz from '@components/pages/cpa/epnbz';
import CpaEpnCpa from '@components/pages/cpa/epncpa';

// HOCs
import WithRole, { rolesEnum } from '@HOCs/WithRole';
import { CustomGetStaticPathsResult, CustomGetStaticPropsResult } from '../../../types';

const CpaPage: React.FC = () => {
    if (process.env.NEXT_PUBLIC_PROJECT_NAME === 'epncpa') {
        return <CpaEpnCpa />;
    }
    return <CpaEpnbz />;
};

export const getStaticProps: GetStaticProps = async ({
    params,
}): Promise<CustomGetStaticPropsResult> => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async (): Promise<CustomGetStaticPathsResult> => {
    return { paths: getLocalePaths(), fallback: false };
};

export default WithRole(CpaPage, [rolesEnum.guest]);
